import * as yup from 'yup';

export const CreateBookingApprovalSchema = yup.object({

});
